import React, { useEffect, useState } from 'react';
import {
    Table,
    Row,
    Col,
    Tabs,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import HeaderSearch from '../../../components/HeaderSearch';
import {
    getSoilProperty,
    getEstimationMethod,
    getExtReferenct
} from '../../../util/Request';
import { RootState } from '../../../redux';
import {
    getSoilPropertyD,
    getMethodD,
    getExtReferenctD,
} from '../../../redux/reducer/referenceData';

export default function Reference() {
    //table
    function onChange() {
        console.log(111111111);
    }
    //columns 1
    const columns = [
        {
            title: 'Property',
            dataIndex: 'cName',
            width: '330px',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return {
                        colSpan: 6,
                    };
                }
            },
            render: (param1, param2, index) => {
                const check = checkShowHeader(index);

                const element = check ? (
                    <div className={'title-span-reference-div'}><span className={'title-span-reference'}>{param1}</span></div>
                ) : <div className='default-table-height' ><span>{param1}</span></div>;
                return element;
            }
        },
        {
            title: 'Category',
            dataIndex: 'category',
            width: '100px',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Component',
            dataIndex: 'component',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'XRD SID',
            dataIndex: 'xrD_ID',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Validity in Days',
            dataIndex: 'validityPeriod',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            style: 'text-align:right',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
    ];
    //dataSource1
    //columns 2
    const columns2 = [
        {
            title: 'Estimation Method',
            dataIndex: 'methodName',
            width: '330px',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return {
                        colSpan: 7,
                    };
                }
            },
            // render: (text, index) =>
            //     checkShowHeader(index) ? (
            //         <tr style={{ backgroundColor: 'red', fontWeight: 500 }}></tr>
            //     ) : <span>{text}</span>,
            render: (param1, param2, index) => {
                const check = checkShowHeader(index);
                const element = check ? (
                    <div className={'title-span-reference-div'}><span className={'title-span-reference'}>{param1}</span></div>
                ) : <div className='default-table-height' ><span>{param1}</span></div>;
                return element;
            }
        },
        {
            title: 'Estimation Method Type',
            width: '230px',
            dataIndex: 'methodNameType',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'XRD SID',
            dataIndex: 'xrD_ID',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Min Value',
            dataIndex: 'minValue',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Max Value',
            dataIndex: 'maxValue',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
        {
            title: 'Units',
            dataIndex: 'units',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        }
    ];
    //columns 3
    const columns3 = [
        {
            title: 'External Object',
            dataIndex: 'externalObject',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return {
                        colSpan: 2,
                    };
                }
            },
            render: (param1, param2, index) => {
                const check = checkShowHeader(index);
                const element = check ? (
                    <div className={'title-span-reference-div'}><span className={'title-span-reference'}>{param1}</span></div>
                ) : <div className='default-table-height' ><span>{param1}</span></div>;
                return element;
            }
        },
        {
            title: 'Description',
            dataIndex: 'description',
            style:'text-align:center',
            onCell: (_, index) => {
                if (checkShowHeader(index)) {
                    return { colSpan: 0 };
                }
            },
        },
    ];
    //tabs
    function callback(key) {
        //console.log(key);
        setTabkey(key);
    }

    //search
    const [searchValue, setSearchValue] = useState('');
    const [tabkey, setTabkey] = useState(1);

    const onSearch = (value: string) => {
        //console.log('search value is ' + value);
        setSearchValue(value);
    };
    // =================  define dispatch and get value from store ===================
    const dispatch = useDispatch();

    const { soilPropertyList, methodList, extList, indexAction } = useSelector((state: RootState) =>
        state.referencePageData);
    //console.log('soilPropertyList new Value: ', soilPropertyList);
    const getProperty = async () => {
        const response = await getSoilProperty(searchValue);
        //console.log('response: ==', response);
        dispatch(getSoilPropertyD({ soilPropertyList: response.list, extList: [], methodList: [], indexAction: response.indexs }));
        //console.log('indexAction: ==', indexAction);
    };
    const checkShowHeader = (index: number): boolean => {
        if (indexAction.indexOf(index) == -1) {
            return false;
        }
        else {
            return true;
        }
    };
    //EstimationMethod
    // const getMethod = useCallback(async () => {
    const getMethod = async () => {
        const response = await getEstimationMethod(searchValue);
        //console.log('response: ==', response);
        dispatch(getMethodD({ soilPropertyList: [], methodList: response.list, extList: [], indexAction: response.indexs}));
        //}, []);
    };
    //ExtReferenct
    //const getReferenct = useCallback(async () => {
    const getReferenct = async () => {
        const response = await getExtReferenct(searchValue);
        //console.log('response: ==', response);
        dispatch(getExtReferenctD({ extList: response.list, soilPropertyList: [], methodList: [], indexAction: response.indexs}));
        //}, []);
    };
    useEffect(() => {
        //if(searchValue != ''){
        if (tabkey == 1) {
            //console.log('this is 1 searchVlaue: ', searchValue);
            getProperty();
        }
        if (tabkey == 2) {
            //console.log('this is 2 searchVlaue: ', searchValue);
            getMethod();
        }
        if (tabkey == 3) {
            //console.log('this is 3 searchVlaue: ', searchValue);
            getReferenct();
        }
        //}
    }, [searchValue, tabkey]);

    const items = [
        {
            label: 'Soil Properties', key: '1', children: (
                <Row gutter={24}>
                    <Col className="gutter-row" span={24}>
                        <Table columns={columns}
                            dataSource={soilPropertyList}
                            onChange={onChange}
                            rowKey={(record) => `${record.xrD_ID}-${record.cName}`}
                            pagination={false}
                            scroll={{ y: 420 }}
                            sticky={true}
                            rowClassName={(record, index) => {
                                { return checkShowHeader(index) ? 'trBackground' : ''; }
                            }}
                        />
                    </Col>
                </Row>) }, // remember to pass the key prop
        { label: 'Estimation Methods', key: '2', children: (
            <Row gutter={24}>
                <Col className="gutter-row" span={24}>
                    <Table columns={columns2}
                        dataSource={methodList}
                        onChange={onChange}
                        pagination={false}
                        scroll={{ y: 420 }}
                        sticky={true}
                        rowClassName={(record, index) => {
                            { return checkShowHeader(index) ? 'trBackground' : ''; }
                        }}
                    />
                </Col>
            </Row>
        )},
        { label: 'External Reference', key: '3', children: (
            <Row gutter={24}>
                <Col className="gutter-row" span={24}>
                    <Table columns={columns3}
                        dataSource={extList}
                        onChange={onChange}
                        pagination={false}
                        scroll={{ y: 420 }}
                        sticky={true}
                        rowClassName={(record, index) => {
                            { return checkShowHeader(index) ? 'trBackground' : ''; }
                        }}
                    />
                </Col>
            </Row>
        )},
    ];
    return (
        <div className="reference" style={{ width: '98%' }}>
            <h3 className="soliHeader">Reference Data
                {/* <InfoCircleOutlined style={{margin:'5px 0 0 10px'}} /> */}
            </h3>
            <div>
                <HeaderSearch GetAnalyses={onSearch} placeholder='Search'/>
            </div>
            <div className='tableBox'>
                <Tabs id='tabs'onChange={callback} type="card" items={items} style={{ width: '100%' }} />
            </div>
        </div>
    );
}
